"use client"

import { LexicalEditor as WorkspaceLexicalEditor } from "@thangph2146/lexical-editor"
import "@thangph2146/lexical-editor/styles"
import type { LexicalEditorProps } from "@thangph2146/lexical-editor"
export type { LexicalEditorProps, SerializedEditorState } from "@thangph2146/lexical-editor"

export function LexicalEditorWrapper(props: LexicalEditorProps) {
  return <WorkspaceLexicalEditor {...props} />
}
